// extracted by mini-css-extract-plugin
export default {"addForm":"addForm_addForm__yk7E6","formControl":"addForm_formControl__OYOQ3","list":"addForm_list__MKspC","btnWrpper":"addForm_btnWrpper__lFUvL"};